<template>
    <div :class="{ 'data-entry-note-edit': true, focused }">
        <div :title="updatedDate">{{ createdDate }}</div>
        <div>{{ editing.user.firstName }} {{ editing.user.lastName }}</div>
        <mt-input type="textarea" v-model="editing.noteText" :rows="-1" @focus="focused = true" />
        <div class="button-group">
            <button class="secondary" @click.prevent="cancel" :disabled="!changed && !focused">Cancel</button>
            <button class="primary" @click.prevent="commit" :disabled="!changed || !valid">Save</button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        autofocus: {
            type: Boolean,
            default: false,
        },
        note: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            editing: { ...this.note },
            focused: this.autofocus,
        }
    },
    watch: {
        note: {
            deep: true,
            handler() {
                this.editing = { ...this.note }
                this.focused = false
            },
        },
    },
    computed: {
        changed() {
            return this.editing.noteText !== this.note.noteText
        },
        createdDate() {
            return this.editing.createdDate ? new Date(this.editing.createdDate).toLocaleString() : ''
        },
        updatedDate() {
            return this.editing.updatedDate ? `Updated ${new Date(this.editing.updatedDate).toLocaleString()}` : ''
        },
        valid() {
            return this.editing.noteText.trim() !== ''
        },
    },
    methods: {
        cancel() {
            this.$emit('cancel', this.note)
        },
        commit() {
            this.$emit('commit', this.editing)
        },
    },
}
</script>
<style>
.data-entry-note-edit {
    display: flex;
    flex-wrap: wrap;
    padding: 8px 16px;

    > {
        :nth-child(1) {
            width: 200px;
        }

        :nth-child(2) {
            flex-grow: 1;
            margin-right: 64px;
            text-align: right;
        }
    }

    div.input {
        width: 100%;
    }

    textarea {
        height: 36px;
        padding: 8px;
        transition: height 0.3s ease-in-out;
    }

    &.focused textarea {
        height: 160px;
    }

    .button-group {
        width: 100%;
    }
}
</style>
